import React, { useMemo, useState } from "react";
import { FaBars } from "react-icons/fa";
import "../assets/css/TopHeader.css";
import { resolveBrand, TUMMA_LOGO_SRC } from "../utils/brand";

/**
 * Mobile header: logo and "<COMPANY> OFFICE OS" on the left, nav toggle on the right.
 */
function TopHeader({ onToggleSidebar }) {
  const brand = useMemo(() => resolveBrand(), []);
  const [logoFailed, setLogoFailed] = useState(false);

  if (!onToggleSidebar) {
    return null;
  }

  return (
    <div className="top-header top-header--content-chrome">
      <div className="header-content header-content--mobile-brand">
        <div className="header-brand" title={brand.name}>
          <img
            src={brand.logo && !logoFailed ? brand.logo : TUMMA_LOGO_SRC}
            alt=""
            className="header-brand__mark"
            onError={() => setLogoFailed(true)}
          />
          <span className="header-brand__name">
            <span className="header-brand__office">{brand.companyWord} OFFICE</span>{" "}
            <span className="header-brand__os">OS</span>
          </span>
        </div>

        <div className="header-title-row header-title-row--end">
          {onToggleSidebar ? (
            <button
              type="button"
              className="sidebar-toggle"
              onClick={onToggleSidebar}
              aria-label="Toggle navigation menu"
            >
              <FaBars size={18} />
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default TopHeader;
